import React from "react";
import { connect } from "react-redux";
import ProjectListContainer from "./project-list-container";

const InternalProjectList = ({ projects }) => (
  <ProjectListContainer projects={projects} />
);

const mapStateToProps = state => {
  return { projects: state.internalProjects };
};

export default connect(mapStateToProps)(ProjectListContainer);
